import { useTranslation } from 'react-i18next';
import { RemoveFile } from '../../common/svg/AllSvg';
import React from 'react';

const FstLstConnectivityFilter = ({ category, selectCategory, setSelectCategory, mobile, colors, select, loading1 }: any) => {
    const { t } = useTranslation('common');
    const loaderData: any[] = [1, 2, 3, 4, 5]

    const handleCategory = (id: any) => {
        if (selectCategory?.includes(id)) {
            let arr: any[] = selectCategory?.filter((item: any) => item !== id)
            setSelectCategory(arr)
        } else {
            setSelectCategory([...selectCategory, id])
        }
    }

    return (
        <div className={` w-full h-full flex flex-col gap-[20px] ${mobile ? "p-[30px]" : "py-[15px] xlx:py-[30px]"}`}>
            <div className='flex items-center justify-between w-full pr-[24px]'>
                <h4 className="text-primaryText dark:text-white font-bold">{(selectCategory?.length > 0) ? `${selectCategory?.length} ${t("passenger.home.know_st.filter.filtered")}` : `${t("passenger.home.know_st.st.filter")}`}</h4>

                {(selectCategory?.length > 0) && <button className='flex items-center gap-[8px] text-danger dark:text-darkDanger text-sm !leading-tight font-medium focus:shadow-[0_0_0_2px_#ff00005e] hover:shadow-[0_0_0_2px_#ff00005e] focus:rounded-[4px] hover:rounded-[4px] py-[1px] px-[6px]' onClick={() => setSelectCategory([])}><RemoveFile className="fill-danger dark:fill-darkDanger" /> {t("passenger.home.know_st.filter.clear")}</button>}
            </div>


            {loading1 ?
                <div className='pr-[24px] flex flex-col gap-[20px] xlx:gap-[25px] w-full'>
                    <div className="w-[70px] h-[8px] bg-gray-200 rounded-full dark:bg-gray-700"></div>

                    <div className="gap-x-[8px] gap-y-[10px] flex items-center flex-wrap">
                        {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                            <div key={index} className='min-w-[110px] h-[30px] xlx:h-[34px] rounded-[8px] xlx:rounded-[12px] bg-gray-200 dark:bg-gray-700'></div>
                        ))}
                    </div>
                </div>
                :
                <div className={`flex flex-col gap-[20px] xlx:gap-[25px] ${mobile ? "overflow-y-auto h-[calc(100%-45px)]" : ""}`}>
                    {!!select && <div className="pr-[24px] flex flex-col gap-[20px] xlx:gap-[25px]">
                        {Array.isArray(category) && category?.map((item: any, index: number) => (
                            <React.Fragment key={index}>
                                {(item?.place_types?.length > 0 && select === item?.id) && <div className="flex flex-col gap-[10px] xlx:gap-[12px]" >
                                    <p className="text-blackDark dark:text-textBlackDark font-semibold">{t("passenger.lost_found.list.category")}</p>

                                    <div className="gap-x-[8px] gap-y-[10px] flex items-center flex-wrap">
                                        {Array.isArray(item?.place_types) && item?.place_types?.map((i: any, idx: number) => (
                                            <button key={idx} className={`${selectCategory?.includes(i?.id) ? `${colors[i?.class_name]?.border} ${colors[i?.class_name]?.text} ${colors[i?.class_name]?.focusShadow} ${colors[i?.class_name]?.hoverShadow}` : "border-[#E6E6E6] text-blackDull dark:text-textBlackDull text-opacity-[0.7] border-opacity-[0.7] focus:shadow-xl hover:shadow-xl"} border-2 rounded-[8px] xlx:rounded-[12px] flex items-center gap-[8px] h-[30px] xlx:h-[34px] justify-center px-[12px] xlx:px-[15px] text-sm !leading-tight font-semibold`} onClick={() => handleCategory(i?.id)}>
                                                <img src={i?.image?.file} alt={i?.name} className={`${selectCategory?.includes(i?.id) ? "" : "facility-icon opacity-[0.7]"} w-[20px] h-[20px]`} />
                                                {i?.name}</button>
                                        ))}
                                    </div>
                                </div>}
                            </React.Fragment>
                        ))}
                    </div>}
                </div>}
        </div>
    );
};

export default FstLstConnectivityFilter;